import React, { Fragment, useEffect, useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { isProd } from "Services/utils";
import store from "Store";

// QA key from google docs https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do
const qaKey = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
const key = "6Ld4sYolAAAAAISnMSSrdRrmiWHZv4DwzIsKYwtI";

export const reCaptchaKey = isProd ? key : qaKey;

export function Captcha({ onTokenRecieved, formError, touched, apiErroredOnCaptcha, setApiErroredOnCaptcha }) {
    const [error, setError] = useState(null);
    const [render, setRender] = useState(true);
    const captcha = useRef(null);

    const locale = store.getState().locale.locale;

    useEffect(() => {
        try{
            setError(null);
            setApiErroredOnCaptcha(null);
            onTokenRecieved(null);
            setRender(false); 
            captcha.current.reset();
            setTimeout(() => setRender(true), 500);
        }catch(e){
            //pass
        }
    }, [locale]);

    useEffect(() => {
        if (apiErroredOnCaptcha) {
            onTokenRecieved(null);
            captcha.current.reset();
        }
    }, [apiErroredOnCaptcha]);

    return (
        <Fragment>
            {render && (
                <ReCAPTCHA
                    ref={captcha}
                    sitekey={reCaptchaKey}
                    onChange={e => {
                        onTokenRecieved(e);
                        setApiErroredOnCaptcha(null);
                    }}
                    onExpired={() => onTokenRecieved(null)}
                    onErrored={setError}
                    hl={locale}
                />
            )}
            {(error || apiErroredOnCaptcha || (formError && touched)) && (
                <div style={{ color: "#f44336", fontSize: "0.75rem" }} data-testid="error_recaptcha">
                    {error || formError || apiErroredOnCaptcha}
                </div>
            )}
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/components/StartContainer/components/Captcha.js